import { AppContext, ComponentPublicInstance, createVNode, render } from 'vue'
import UploadPracticeDialog from './uploadPracticeDialog.vue';
let localAppContext = null;
export const setUploadPracticeDialogAppContext = (context: AppContext) => {
    localAppContext = context;
}

const dialogInstance = new Map<ComponentPublicInstance<({ visible: boolean })>, any>();
const initInstance = (component: any, props: any, container: HTMLElement, appContext: AppContext | null = null) => {
    const vnode = createVNode(component, props);
    vnode.appContext = appContext;
    render(vnode, container);
    let root = appContext ? appContext.app._container : document.body;
    if (!root) root = document.getElementById('app') || document.body;
    root.appendChild(container.firstElementChild!);
    return vnode.component;
}
const getContainer = () => {
    return document.createElement('div');
}
const showDialog = (component: any, options: any, examId: any, caseQuestionId: any, userId: any, attachmentUri: any, appContext: AppContext | null = null) => {
    const container = getContainer();
    const p = new Promise(function (resolve) {
        const onConfirm = options.onConfirm;

        options.examId = examId;
        options.caseQuestionId = caseQuestionId;
        options.userId = userId;
        options.attachmentUri = attachmentUri;
        options.onConfirm = (data, code) => {
            if (onConfirm) onConfirm(data, code);
            resolve(Object.assign({}, data, { action: code }));
        }
        const onClose = options.onClose;
        options['onClose'] = () => {
            const props = dialogInstance.get(vm);
            props.visible = false;
            if (onClose) onClose();
            resolve(null);
        }
    })

    options.visible = true;
    const instance = initInstance(component, options, container, appContext);
    const vm = instance.proxy as ComponentPublicInstance<({ visible: boolean })>;
    dialogInstance.set(vm, instance.props)
    return p;
}
async function openUploadPracticeDialog(examId: any, caseQuestionId: any, userId: any, attachmentUri: any, appContext: AppContext | null = null) {
    return showDialog(UploadPracticeDialog, {}, examId, caseQuestionId, userId, attachmentUri, appContext || localAppContext);
}

export { openUploadPracticeDialog };